import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

// set up the reactive global object
const global = new Vue({data:{loading: false}});

// make a plugin to add it to Vue
const GlobalPlugin = {
  install(Vue){
    Vue.prototype.$global = global
  }
};

Vue.use(GlobalPlugin);

Vue.http.interceptors.push((request, next)  => {
    // request.headers['Authorization'] = auth.getAuthHeader()
    // 1 minute timeout on all requests
    request.timeout = 60000;
    if(typeof request.hidden === 'undefined' || !request.hidden) {
        global.loading = true;
    }
    
    next((response) => {
        // small delay on loader?
        setTimeout(() => {
          if(typeof request.chained === 'undefined' || !request.chained) {
            global.loading = false;
          }
        }, 1200);
    });
});


// WEBPACK FOOTER //
// ./src/plugins/resource.js